import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {Quote} from '../model/quote';
import {QuoteCreateCommand, QuoteEditCommand, QuoteRequestCommand} from '../model/quote-commands';
import {QuoteEntity} from '../model/quote-entity';
import {AbstractQuoteService, quotesErrorSelector} from './abstract-quote.service';
import {QuotesErrors} from '../model/quotes-error';

@Injectable()
export class QuoteService extends AbstractQuoteService {
    constructor(private http: HttpClient) {
        super();
    }

    createQuote(quoteCreate: QuoteCreateCommand): Observable<Quote> {
        const requestBody = {
            name: quoteCreate.name
        };

        return this.http.post<QuoteEntity>(this.determineQuotesResourceUrl(), requestBody).pipe(
            tap(response => console.log(response)),
            map(quote => this.convertToQuote(quote)),
            catchError(err => quotesErrorSelector(err))
        );
    }

    deleteQuote(quote: Quote): Observable<Object> {
        return this.http.delete(this.determineQuoteResourceUrl(quote)).pipe(
            tap(response => console.log(response)),
            catchError(err => quotesErrorSelector(err))
        );
    }

    editQuote(quoteEdit: QuoteEditCommand): Observable<Quote> {
        const requestBody = {
            name: quoteEdit.name
        };

        const url = this.determineQuoteResourceUrl(quoteEdit.quote);
        return this.http.put<QuoteEntity>(url, requestBody).pipe(
            tap(response => console.log(response)),
            map(quote => this.convertToQuote(quote)),
            catchError(err => quotesErrorSelector(err))
        );
    }

    downloadQuote(quote: Quote): Observable<Blob> {
        const url = this.determineQuoteDownloadResourceUrl(quote);
        return this.http.get(url, {
            responseType: 'blob'
        }).pipe(
            catchError(err => quotesErrorSelector(err, QuotesErrors.UNAUTHORIZED)
        ));
    }

    request(quoteRequestCommand: QuoteRequestCommand): Observable<Quote> {
        const requestBody = {
            address: quoteRequestCommand.address,
            isOrder: quoteRequestCommand.isOrder
        };

        const url = this.determineQuoteRequestResourceUrl(quoteRequestCommand.quote);
        return this.http.put<QuoteEntity>(url, requestBody).pipe(
            tap(response => console.log(response)),
            map(quote => this.convertToQuote(quote)),
            catchError(err => quotesErrorSelector(err))
        );
    }
}
